import script from "./ParsingItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ParsingItem.vue?vue&type=script&setup=true&lang=js"

import "./ParsingItem.vue?vue&type=style&index=0&id=5d8d7d06&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8d7d06"]])

export default __exports__